import React from 'react';
import {Text, Flex, PriorityIcon, Icon} from '@priority-software/priority-style-react';
import texts from '../texts';
import {ActionsSubtitleType} from '../consts';
import styles from '../styles/actionsList.module.scss';
import {helpPopoverRef} from '../../../_shared/Help/constants';

const getActionsListHelp = () => {
    const helpParts = texts.actionsListHelp.split(/([%])/g);
    const boldSatrt = helpParts.indexOf('%');
    const boldEnd = helpParts.lastIndexOf('%');

    return (
        <Text componentClasses={styles.helpFonts}>
            {helpParts.map((part, idx) => {
                if (idx === boldSatrt || idx === boldEnd) {
                    return '';
                } else if (idx === boldEnd - boldSatrt) {
                    return (
                        <Text
                            fontWeight="bold"
                            tag="span"
                            key="helpSpan"
                            componentClasses={styles.helpFonts}
                        >
                            {part}
                        </Text>
                    );
                } else {
                    return part;
                }
            })}
        </Text>
    );
};

const handleShowHelpMessage = (actionsSubtitleType, e) => {
    const content =
        actionsSubtitleType === ActionsSubtitleType.quickAccess
            ? texts.quickAccessHelp
            : getActionsListHelp();
    helpPopoverRef.current.showHelpPopover({content, anchor: e.target});
};

export const ActionsSubtitle = ({actionsSubtitleType}) => {
    const handleHelp = e => {
        e.stopPropagation();
        handleShowHelpMessage(actionsSubtitleType, e);
    };
    return (
        <Flex justifyContent="flex-start" componentClasses={styles.label}>
            <Text componentClasses={styles.labelText}>{texts[actionsSubtitleType]}</Text>
            <Icon
                componentClasses={styles.labelIcon}
                icon={PriorityIcon.questionCircle}
                onClick={e => handleHelp(e)}
            />
        </Flex>
    );
};
